import { createContext, useEffect, useState, useRef } from "react";
import router from "next/router";
import { jsx as _jsx } from "react/jsx-runtime";
export const PreviousPathContext = /*#__PURE__*/createContext();
PreviousPathContext.displayName = "PreviousPathContext";
const ignorePath = ["login", "signup", "profiles", "account", "password_remind", "profile_pincode_reset", "restricted"];
export function PreviousPathProvider(_ref) {
  let {
    children
  } = _ref;
  const previousPath = useRef();
  const {
    0: _path,
    1: setPath
  } = useState();
  useEffect(() => {
    const handler = url => {
      setPath(prev => {
        if (prev && !ignorePath.find(path => prev.match(new RegExp(path)))) {
          previousPath.current = prev;
        }
        return url;
      });
    };
    handler(router.asPath);
    router.events.on("routeChangeComplete", handler);
    return () => {
      router.events.off("routeChangeComplete", handler);
    };
  }, []);
  return /*#__PURE__*/_jsx(PreviousPathContext.Provider, {
    value: previousPath.current,
    children: children
  });
}